export default {
  methods: {
    convertSingleNode(intent) {
      var i = intent
      try {
        i.answer = JSON.parse(intent.answer)

        if (typeof i.answer == 'string') {
          i.answer = JSON.parse(i.answer)
        }
      } catch (error) {
        i.answer = []
      }
      try {
        i.connected_intents =
          intent.connected_intents != null ? JSON.parse(intent.connected_intents) : []

        if (typeof i.connected_intents == 'string') {
          i.connected_intents = JSON.parse(i.connected_intents)
        }
      } catch (error) {
        i.connected_intents = []
      }
      i.userinput = {}
      if (i.x == null) {
        i.x = 0
      }
      if (i.y == null) {
        i.y = 0
      }
      return i
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/flowMixin.js